import { $generateNodesFromDOM } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getEditor, $getRoot, $insertNodes } from 'lexical';
import { useEffect } from 'react';
import { ContentTypes } from 'const';

export function $setEditorStateFromHtmlString(html: string): void {
  // Use the native DOMParser API to parse the HTML string
  const parser = new DOMParser();
  const dom = parser.parseFromString(html, ContentTypes.TEXT_HTML);

  // Generate LexicalNodes
  const editor = $getEditor();
  const nodes = $generateNodesFromDOM(editor, dom);

  // Remove automatically created paragraph
  const emptyParagraph = $getRoot().getFirstChild();
  if (emptyParagraph) {
    emptyParagraph.remove();
  }

  // Select the root
  $getRoot().select();

  // Insert LexicalNodes at a selection
  $insertNodes(nodes);
}

type Props = {
  html: string | undefined;
};

export function HtmlContentPlugin(props: Props): null {
  const { html } = props;
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (editor && html) {
      editor.update(() => $setEditorStateFromHtmlString(html));
    }
  }, [editor, html]);

  return null;
}
